import React, { useEffect, useState } from "react";
import Provider from "./Provider";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

function RaingAndReview() {
  const { allReview, isLoading } = Provider();

  const [filteredReviews, setFilteredReviews] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [ReviewsStatusFilter, setReviewsStatusFilter] = useState("");
  const rowsPerPage = 10;

  console.log("All REVIEWW ::", allReview);

  useEffect(() => {
    setFilteredReviews(allReview);
  }, [allReview]);

  useEffect(() => {
    const filtered = allReview?.filter((review) => {
      const reviewRating = review?.rating;

      const matchRating =
        ReviewsStatusFilter === "" ||
        parseInt(ReviewsStatusFilter) === reviewRating;

      return (
        matchRating &&
        (reviewRating === 5 ||
          (reviewRating >= 4 && reviewRating < 5) ||
          (reviewRating >= 3 && reviewRating < 4) ||
          (reviewRating >= 2 && reviewRating < 3) ||
          (reviewRating >= 1 && reviewRating < 2))
      );
    });

    setFilteredReviews(filtered);
  }, [allReview, ReviewsStatusFilter]);

  // Pagination Logic
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentReviews = filteredReviews?.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredReviews?.length / rowsPerPage);

  return (
    <div className="p-2 bg-white shadow-xl font-Poppins rounded-xl mx-4">
      <div className="flex items-center justify-between px-4 py-4 ">
        <h1 className="text-2xl font-semibold ">All Rating & Reviews</h1>

        {/* Search Bar */}

        <div className="flex items-center">
          <select
            value={ReviewsStatusFilter}
            onChange={(e) => setReviewsStatusFilter(e.target.value)}
            className="border border-gray-300 rounded-lg px-6 py-2 text-md font-medium focus:outline-none focus:ring focus:border-blue-300"
          >
            <option value="" className="font-medium">
              All
            </option>
            <option value="5" className="font-medium">
              5 ☆☆☆☆☆
            </option>
            <option value="4" className="font-medium">
              4 ☆☆☆☆
            </option>
            <option value="3" className="font-medium">
              3 ☆☆☆
            </option>
            <option value="2" className="font-medium">
              2 ☆☆
            </option>
            <option value="1" className="font-medium">
              1 ☆
            </option>
          </select>

          {/* <div className="relative w-full w-1/2">
            <input
              type="text"
              placeholder="Search..."
              className="border border-gray-300 rounded-lg px-4 py-2 pr-10 w-full focus:outline-none focus:ring focus:border-blue-300"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700 focus:outline-none"
                onClick={() => setSearchTerm("")}
              >
                ✕
              </button>
            )}
          </div> */}
        </div>
      </div>

      {/* Table */}

      {isLoading ? (
        <>
          <div className="flex my-[10%] justify-center items-center">
            <div className="w-8 h-8 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-blue-500"></div>
          </div>
        </>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              {currentReviews ? (
                <>
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-3 py-3 text-left text-sm font-medium text-gray-600">
                        S No.
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Customer Name & Mobile
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Driver Name & Mobile
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Rating
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Review
                      </th>

                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Ride Status
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Ride Type
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-gray-600">
                        Review Date
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm divide-y divide-gray-200">
                    {currentReviews?.map((review, index) => (
                      <tr key={review?.id}>
                        <div className="px-6 py-4 flex items-center">
                          {index + 1}
                        </div>

                        <td className="px-6 py-4">
                          <div className="font-medium my-1">
                            {review?.user_name || "--"}
                          </div>
                          <div className="font-medium my-1">
                            {review?.user_mobile_number || "--"}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="font-medium my-1">
                            {review?.driver_name || "--"}
                          </div>
                          <div className="font-medium my-1">
                            {review?.driver_mobile_number || "--"}
                          </div>
                        </td>

                        {/* Star Rating */}
                        <td className="px-6 py-4 flex items-center gap-1">
                          {Array.from({ length: 5 }, (_, i) =>
                            i < (review?.rating || 0) ? (
                              <StarIcon key={i} className="text-yellow-400" />
                            ) : (
                              <StarBorderIcon
                                key={i}
                                className="text-gray-400"
                              />
                            )
                          )}
                        </td>

                        {/* <td className="px-6 py-4">{review?.rating || "--"}</td> */}

                        <td className="px-6 py-4">{review?.review || "--"}</td>

                        <td className="px-6 py-4">
                          <span
                            // onClick={() => handleAccountStatusChange(driver)}
                            className={`px-2 py-1 text-xs font-semibold cursor-pointer rounded-lg ${
                              review?.status === "Completed"
                                ? "text-green-600 bg-green-100"
                                : review?.status === "Biding"
                                ? " text-gray-600 bg-gray-100"
                                : "text-red-600 bg-red-100"
                            }`}
                          >
                            {review?.status}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          {review?.trip_type || "--"}
                        </td>

                        <td className="px-6 py-4">
                          {new Date(review?.created_at).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : (
                <>
                  <div className="my-[10%] font-medium font-Poppins text-3xl flex items-center justify-center">
                    No Review Found!
                  </div>
                </>
              )}
            </table>
          </div>
        </>
      )}

      {/* Pagination */}

      {currentReviews && (
        <div className="flex justify-between items-center mt-4">
          <span className="text-sm text-gray-600">
            Showing {startIndex + 1}-
            {Math.min(endIndex, filteredReviews?.length)} of{" "}
            {filteredReviews?.length}
          </span>
          <div className="flex">
            <button
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-200 ml-2"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default RaingAndReview;
